import React, { useState } from "react";
import { toast } from "react-toastify";
import contact from "../../images/LandingPageImage/contact.png";
import useContactForm from "../../services/LandingPage/useContactForm";

const GetInTouch = () => {
  const { submitContactForm, loading } = useContactForm();

  const [formData, setFormData] = useState({
    fullName: "",
    phoneNumber: "",
    workEmail: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.fullName || !formData.phoneNumber || !formData.workEmail) {
      toast.error("Please fill all required fields");
      return;
    }

    const result = await submitContactForm(formData);

    if (result.success) {
      toast.success("Form submitted successfully");
      setFormData({
        fullName: "",
        phoneNumber: "",
        workEmail: "",
        message: "",
      });
    } else {
      toast.error(result.message);
    }
  };

  return (
    <> 

    <section className="py-16 bg-white">
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex flex-col lg:flex-row items-center gap-12">
          {/* LEFT SIDE */}
          <div className="lg:w-1/2">
            <div className="mb-6">
              <img
                src={contact}
                alt="Contact"
                className="w-full max-w-[360px] rounded-lg"
              />
            </div>

            <h2 className="text-3xl font-bold text-[#0C4D45] mb-4">
              We’re Here to <br /> Support Your Business Growth
            </h2>

            <p className="text-gray-600 max-w-[420px]">
              Have questions or need assistance? Our dedicated team is always
              ready to help.
            </p>
          </div>

          {/* RIGHT FORM */}
          <div className="lg:w-1/2 w-full">
            <div className="border border-[#1ec997] rounded-xl bg-white p-6 md:p-10">
              <h4 className="text-center text-xl font-semibold text-[#0C4D45] mb-6">
                Get in Touch
              </h4>

              <form onSubmit={handleSubmit} className="space-y-4">
                <input
                  type="text"
                  name="fullName"
                  placeholder="Full Name"
                  value={formData.fullName}
                  onChange={handleChange}
                  className="w-full border rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-green-500"
                />

                <input
                  type="tel"
                  name="phoneNumber"
                  placeholder="Phone Number"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  className="w-full border rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-green-500"
                />

                <input
                  type="email"
                  name="workEmail"
                  placeholder="Work Email"
                  value={formData.workEmail}
                  onChange={handleChange}
                  className="w-full border rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-green-500"
                />

                <textarea
                  name="message"
                  rows="4"
                  placeholder="Message"
                  value={formData.message}
                  onChange={handleChange}
                  className="w-full border rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-green-500"
                ></textarea>

                <button
                  type="submit"
                  disabled={loading}
                  className="w-full py-3 font-semibold text-white bg-[#00c97f] rounded-lg hover:bg-green-600 transition disabled:opacity-50"
                >
                  {loading ? "Submitting..." : "Submit"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
    </>
  );
};

export default GetInTouch;
